// extracted by mini-css-extract-plugin
export default {"wrap":"PriceTableComponent_wrap__q3PCE","header":"PriceTableComponent_header__xJnes","container":"PriceTableComponent_container__E639B"};